import { render, staticRenderFns } from "./advanced-payer-update-icon.vue?vue&type=template&id=1dc51d18"
import script from "./advanced-payer-update-icon.vue?vue&type=script&lang=js"
export * from "./advanced-payer-update-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports